import type { IFooterProps, IIbarProps } from "@frontiers-vue3/public-pages";
import { useApiService } from "./useApiService";
import type { IContentfulJournal } from "~/types/contentful/IContentfulJournal";

export const useJournalPagesService = () => {
  const { journalsPagesUrl } = useRuntimeConfig().public;
  const { getFetchData } = useApiService();

  const getIbarComponent = async (journalId?: number): Promise<IIbarProps> => {
    const endpoint = journalId
      ? `${journalsPagesUrl}/components/ibar?journalId=${journalId}`
      : `${journalsPagesUrl}/components/ibar`;

    try {
      return await getFetchData(endpoint, "ibar");
    } catch (err: unknown) {
      throw Error(
        `Error getting the ibar with journalId '${journalId}'. Message: ${
          err instanceof Error ? err.message : err
        }`
      );
    }
  };

  const getFooterComponent = async (): Promise<IFooterProps> => {
    try {
      return getFetchData(`${journalsPagesUrl}/components/footer`, "footer");
    } catch (err: unknown) {
      throw Error(
        `Error getting footer. Message: ${
          err instanceof Error ? err.message : err
        }`
      );
    }
  };

  const getContentfulJournal = async (
    journalSlug: string
  ): Promise<IContentfulJournal> => {
    try {
      return getFetchData(
        `${journalsPagesUrl}/journals/${journalSlug}`,
        "journalInfo-colorScheme",
        false
      );
    } catch (err: unknown) {
      throw Error(
        `Error getting journal info of slug ${journalSlug}. Message: ${
          err instanceof Error ? err.message : err
        }`
      );
    }
  };

  return { getIbarComponent, getFooterComponent, getContentfulJournal };
};
